function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M156.1 49.8l-11.4 22.4-21.1 41.4h59.9l-38.1 56v-35.2H92.6l43.2-84.7 20.3.1m46.5-28.5h-84.3L46 163h70.9v99.2L237.4 85.1h-67.3l32.5-63.8z"
})));